import React from 'react';
import { reloadForUpdate } from '../utils/versionCheck';
import '../styles/VersionUpdateNotification.css';

const VersionUpdateNotification = ({ 
  currentVersion, 
  latestVersion, 
  onDismiss,
  show = true 
}) => {
  if (!show) return null;

  const handleUpdate = () => {
    reloadForUpdate();
  };

  const handleDismiss = () => {
    if (onDismiss) {
      onDismiss();
    }
  };

  const isNewerBuild = latestVersion === 'newer';

  return (
    <div className="version-update-notification">
      <div className="version-update-content">
        <div className="version-update-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L13.09 8.26L16 7L14.74 10.91L19 12L14.74 13.09L16 17L13.09 15.74L12 22L10.91 15.74L8 17L9.26 13.09L5 12L9.26 10.91L8 7L10.91 8.26L12 2Z" fill="currentColor"/>
          </svg>
        </div>
        
        <div className="version-update-text">
          <h4>Neue Version verfügbar!</h4>
          <p>
            {isNewerBuild 
              ? "Eine neuere Version der Anwendung ist verfügbar."
              : `Version ${latestVersion} ist verfügbar (aktuell: ${currentVersion})`
            }
          </p>
          <p className="version-update-subtext">
            Laden Sie die Seite neu, um die neuesten Funktionen und Verbesserungen zu erhalten.
          </p>
        </div>
        
        <div className="version-update-actions">
          <button 
            className="version-update-btn version-update-btn-primary"
            onClick={handleUpdate}
          >
            Jetzt aktualisieren
          </button>
          <button 
            className="version-update-btn version-update-btn-secondary"
            onClick={handleDismiss}
          >
            Später
          </button>
        </div>
        
        <button 
          className="version-update-close"
          onClick={handleDismiss}
          aria-label="Schließen"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default VersionUpdateNotification;
